import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import EnquiryForm from "@/components/EnquiryForm";
import { EASE } from "@/components/Reveal";

export default function EnquiryModal() {
  const { enquiry, closeEnquiry } = useShop();

  return (
    <AnimatePresence>
      {enquiry.open && (
        <>
          <motion.div
            className="fixed inset-0 z-[90] bg-[#1C1712]/60 backdrop-blur-sm"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={closeEnquiry}
            data-testid="enquiry-overlay"
          />
          <motion.div
            className="fixed inset-x-4 top-1/2 z-[95] mx-auto max-w-lg -translate-y-1/2 bg-surface border border-gold/30 shadow-2xl sm:inset-x-auto sm:right-8 sm:left-auto sm:w-[520px]"
            initial={{ opacity: 0, y: 32, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.45, ease: EASE }}
            data-testid="enquiry-modal"
          >
            <div className="px-6 sm:px-8 py-7">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="overline-tag">Private Concierge</p>
                  <h3 className="font-display text-3xl font-semibold mt-1.5">
                    {enquiry.product ? "About this piece" : "Begin your heirloom"}
                  </h3>
                  {enquiry.product && (
                    <p className="mt-1 font-display italic text-gold text-lg">{enquiry.product.name}</p>
                  )}
                </div>
                <button onClick={closeEnquiry} className="h-9 w-9 grid place-items-center text-ink2 hover:text-gold transition-colors" data-testid="enquiry-close">
                  <X size={18} />
                </button>
              </div>
              <div className="gold-hr my-5" />
              <EnquiryForm productName={enquiry.product ? `${enquiry.product.name} (${enquiry.product.category})` : ""} onDone={closeEnquiry} />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
